const sym = Symbol( '@swiper/app' );

export function getApp() {
  if ( typeof window !== 'undefined' ) {
    // eslint-disable-next-line no-undef
    if ( window[ sym ] ) return window[ sym ];
  }
  if ( typeof process !== 'undefined' ) {
    if ( process[ sym ] ) return process[ sym ];
  }
  throw new Error( `Unable to locate app instance` );
}

export function setApp( app ) {
  // eslint-disable-next-line no-undef
  if ( typeof window !== 'undefined' ) return window[ sym ] = app;
  if ( typeof process !== 'undefined' ) return process[ sym ] = app;
  throw new Error( `Unable to store app instance` );
}
